import {AppUri} from '../../constant';
import {Page} from '../../constant/page';
import {IRouteToOption, PageInfo, routeTo, routeToApp} from '../PageRouter';
import {getIsWebView} from '../userAgent';

// 라우팅 취소를 원하면 true를 반환한다
type IRouteCancelObserver = (
  letItGo: () => void,
  params: IRouteToParams | IRouteCancelPosParams
) => boolean;
let observers: IRouteCancelObserver[] = [];
export function subscribeRouteCancel(observer: IRouteCancelObserver) {
  observers.push(observer);
  return () => unsubscribeRouteCancel(observer);
}
function unsubscribeRouteCancel(observer: IRouteCancelObserver) {
  observers = observers.filter(item => item !== observer);
}

export function getIsRouteCancel(
  params: IRouteToParams | IRouteCancelPosParams
) {
  const letItGo = () => {
    if (!getIsRouteToParams(params)) {
      if (
        getIsWebView() &&
        params.currentHistoryPosition - params.relativePos < 0
      ) {
        routeToApp(AppUri.Close);
      } else {
        history.go(-params.relativePos);
      }
    } else {
      routeTo(params.info, params.option);
    }
  };
  return (
    observers.reduce((acc, ob) => (ob(letItGo, params) ? acc + 1 : acc), 0) > 0
  );
}

export function getIsRouteToParams(
  params: IRouteToParams | IRouteCancelPosParams
): params is IRouteToParams {
  return 'page' in params;
}

interface IRouteToParams {
  info: PageInfo | string;
  page: Page;
  option: IRouteToOption;
}

interface IRouteCancelPosParams {
  currentHistoryPosition: number;
  relativePos: number;
}
